import { render } from "./ServiceList.vue?vue&type=template&id=f67427da&scoped=true&ts=true"
import script from "./ServiceList.vue?vue&type=script&lang=ts"
export * from "./ServiceList.vue?vue&type=script&lang=ts"

import "./ServiceList.vue?vue&type=style&index=0&id=f67427da&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f67427da"]])

export default __exports__